import React from 'react';
import { Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { ThemeProvider } from 'styled-components';
import { Button } from '../../../../components';
import light from '../../../../assets/style/themes/dark';
import * as Ui from '../../styles';


export default function PasswordUpdatedCard({ handleSubmit, running }) {
  const theme = light;
  const resStringAccess = 'Tela de login';

  return (
    <ThemeProvider theme={theme}>
      <Ui.Content>
        <h1>Esqueci minha senha</h1>
        <Formik>
          <Form className="form">
            <Ui.TextEnfatic>
              Senha definida com sucesso
            </Ui.TextEnfatic>
            <div className="action">
              <Link to="/"><Button title={resStringAccess} type="submit" loading={running} /></Link>
            </div>
          </Form>
        </Formik>
      </Ui.Content>
    </ThemeProvider>
  );
}
